// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import DentureController from "./denture_controller"
application.register("denture", DentureController)

import DentureControllerV2 from "./denture_v2_controller"
application.register("denture-v2", DentureControllerV2)

import PatientSearchController from "./patient_search_controller"
application.register("patient-search", PatientSearchController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import FormController from "./form_controller"
application.register("form", FormController)